import cn from 'classnames'
import * as React from 'react'

import styles from './checklist.module.scss'
import ChecklistItem from './item'

interface IChecklistProps {
  horizontal?: boolean
  items: React.ReactNode[]
  tight?: boolean
  variant?: 'free' | 'regular'
  center?: boolean
  col?: 1 | 2 | 3
  lastIsSeeMore?: boolean
  noResponsive?: boolean
  handwriting?: boolean
  className?: string
}
const Checklist = ({
  items,
  horizontal,
  tight = false,
  lastIsSeeMore = false,
  variant = 'regular',
  col = 2,
  noResponsive = false,
  handwriting = false,
  className,
  center = false,
}: IChecklistProps) => (
  <ul className={cn(styles.root, horizontal && styles.row, noResponsive && styles.noResponsive, className)}>
    {items.map((item, i) => (
      <li
        className={cn(
          horizontal && col === 1 && styles.itemCol1,
          horizontal && col === 2 && styles.itemCol2,
          horizontal && col === 3 && styles.itemCol3
        )}
        key={React.isValidElement(item) && item.props ? item.props.key : i}
      >
        <ChecklistItem
          center={center}
          handwriting={handwriting}
          inverted={variant === 'free'}
          isSummary={lastIsSeeMore && i + 1 === items.length}
          tight={tight || horizontal || (!horizontal && i + 1 === items.length)}
        >
          {item}
        </ChecklistItem>
      </li>
    ))}
  </ul>
)

export default Checklist
